<template>
  <div class="account-row general-settings">
    <div class="heading">
      <h2>{{$ml.get(`General Settings`)}}</h2>
      <app-btn @click="save">
        {{ $ml.get(`save`) }}
      </app-btn>
    </div>

    <form>
      <app-text-input
        class="general-sel"
        v-for="field in data"
        :label="field.label"
        :type="field.type"
        :disabled="field.disabled"
        v-model="field.value"
        :minlength="field.minlength ? field.minlength : 2"
      />
      <!-- <button type="submit" ref="submit" /> -->
    </form>

  </div>
</template>

<script>

import API from '@/api'

export default {
  props: {
    data : {
      required: true
    }
  },
  data() {
    return {

    }
  },
  methods : {
    save(e) {
      e.preventDefault();
      console.log('save');
      let request = {
        company : this.data.companyName.value,
        // email : this.data.email.value,
        firstName : this.data.firstName.value,
        lastName : this.data.firstName.value,
        phone : this.data.phone.value,
      };
      return API.user.updateGeneralSettings(request).then(res => {
        // if(res.data.success) {
        //   this.$notify({
        //     group: 'notices',
        //     title: this.$ml.get(`Your data was successfully updated!`),
        //     type : 'success',
        //   });
        // }
      }).catch(err => {
        // this.$notify({
        //   group: 'notices',
        //   title: `Error! "${err.response.data.err}"`,
        //   type : 'error',
        // });
      });
    },
  },
}
</script>

<style lang="scss" scoped>

.general-settings {
  .plans-btn {
    width: 200px;
  }
  @media(max-width:768px) {
    .plans-btn {
      width: 100%;
    }
  }

  form {
    >.general-sel {
      margin-bottom: 24px;
    }
  }
}

</style>
